// FREE-WORDS LAW (Founder 30/09/26, after "עורך דין תעבורה ייעוץ חינם" entered a paid campaign):
// a keyword asking for something free is never a paying lead — it NEVER passes the payable tier,
// never enters a topic, never goes to Google, and is added as a NEGATIVE instead.
// ONE door: kwlab.mjs (bids/topics), topic-campaign.mjs (before any mutation), lib/ppc/gates.ts (G-NO-FREE).
const PFX = '[והבלשמכ]{0,3}';
const FREE_HE = ['חינם', 'חינמי', 'חינמית', 'חינמיים', 'חינמיות', 'חנם', 'בחנם'];
const FREE_PHRASES = ['ללא תשלום', 'בלי תשלום', 'ללא עלות', 'בלי עלות', 'ללא כסף', 'בלי כסף', 'לא בתשלום', 'ללא תמורה', 'ללא חיוב', 'פרו בונו'];
const FREE_LATIN = ['free', 'gratis', 'pro bono'];
const esc = s => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
const B = '(?:^|[\\s\\-־"\'.,?!/()])', E = '(?=$|[\\s\\-־"\'.,?!/()])';
const RE = new RegExp(
  `${B}(${PFX}(?:${FREE_HE.map(esc).join('|')})|${PFX}(?:${FREE_PHRASES.map(esc).join('|')})|(?:${FREE_LATIN.map(esc).join('|')}))${E}`, 'i');
/** The forbidden free-word inside a keyword, or null. */
export function forbiddenWord(keyword) {
  const m = RE.exec(` ${String(keyword || '').normalize('NFC')} `);
  return m ? m[1].trim() : null;
}
/** Negatives every paid campaign carries (phrase match). */
export const FREE_NEGATIVES = ['חינם', 'בחינם', 'חינמי', 'חינמית', 'ללא תשלום', 'בלי תשלום', 'ללא עלות', 'free'];
export const FREE_LAW = 'חוק מילות-חינם (30/09): חינם/בחינם/ללא תשלום/free — אף פעם לא בתשלום, תמיד שלילית';

if (process.argv[1]?.endsWith('forbidden.mjs') && process.argv[2] === '--selftest') {
  const yes = ['עורך דין תעבורה ייעוץ חינם', 'ייעוץ משפטי בחינם', 'הצעת מחיר חינמית', 'אינסטלטור ללא תשלום', 'free consultation', 'ייעוץ חינם.', 'וחינם'];
  const no = ['עורך דין תעבורה', 'כמה עולה ניקוי מזגן מיני מרכזי', 'חינוך מיוחד', 'חינני', 'תשלום עורך דין', 'freelancer'];
  const bad = [...yes.filter(k => !forbiddenWord(k)).map(k => `MISS ${k}`), ...no.filter(k => forbiddenWord(k)).map(k => `FALSE ${k}`)];
  console.log(bad.length ? bad.join('\n') : `selftest PASS (${yes.length} blocked, ${no.length} allowed)`);
  process.exit(bad.length ? 1 : 0);
}
